import {DateStepper} from '@hconnect/uikit/src/lib2/components/dateTimeStepper/DateStepper'
import {TimeStepper} from '@hconnect/uikit/src/lib2/components/dateTimeStepper/TimeStepper'
import {Paper, Stack, Typography} from '@mui/material'
import moment, {Moment} from 'moment'
import {useTranslation} from 'react-i18next'

import {COMMON_RUNNING_TIMES_WIDGET_NAMESPACE} from '../consts'

type SplitStoppageProps = {
  splitDate: Moment
  setSplitDate: (date: Moment) => void
  stoppageTimeRange: [Moment, Moment | undefined]
  timezone: string
  tooltipHeader?: string
}

export const StoppageSplitDateTimeEditor = ({
  stoppageTimeRange,
  timezone,
  splitDate,
  setSplitDate,
  tooltipHeader
}: SplitStoppageProps) => {
  const {t} = useTranslation(COMMON_RUNNING_TIMES_WIDGET_NAMESPACE)
  const [stoppageStart, stoppageEnd] = stoppageTimeRange
  const isSameDayStoppage = stoppageStart.isSame(stoppageEnd, 'day')

  return (
    <Paper sx={{p: 3, width: '212px'}} elevation={8}>
      <Stack alignItems="center" gap={2}>
        <Typography variant="h5">{tooltipHeader || t('splitStoppage.label.splitAt')}</Typography>
        {!isSameDayStoppage && (
          <DateStepper
            date={splitDate}
            timezone={timezone}
            dateBound={[stoppageStart, stoppageEnd || moment.tz(timezone)]}
            onChange={(date: Moment) => setSplitDate(date)}
            data-test-id="split-date-stepper"
          />
        )}
        <TimeStepper
          date={splitDate}
          timezone={timezone}
          dateBound={[stoppageStart, stoppageEnd || moment.tz(timezone)]}
          onChange={(date: Moment) => setSplitDate(date)}
          data-test-id="split-time-stepper"
        />
      </Stack>
    </Paper>
  )
}
